import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { interval, Subscription, Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class RolesService {
 
  private baseUrl = `${environment.apiUrl}/script.php`;
  constructor(private http: HttpClient) {}

  getRoles(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}?reqtype=allroles`, data);
  }

  get(id: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}?reqtype=getrole&id=${id}`);
  }

  create(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}?reqtype=newrole`, data);
  }

  update(id: number, data: any): Observable<any> {
    return this.http.put(`${this.baseUrl}?reqtype=updaterole&id=${id}`, data);
  }

  archive(id: number, data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}?reqtype=archiverole&id=${id}`, data);
  }
  restore(roleId: number) {
    return this.http.post(`${this.baseUrl}?reqtype=restorerole`, { roleId });
  }
  delete(id: number, data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}?reqtype=deleterole&id=${id}`, data);
  }

  updateRolePermissions(data: any) {
    return this.http.post(`${this.baseUrl}?reqtype=saveRolePermissions`, data);
  }

  getRolePermissions(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}?reqtype=getRolePermissions`, data);
  }
}

